module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-upload-container"
  }, [_c('label', {
    staticClass: "upload-file",
    attrs: {
      "for": _vm.labelFor
    }
  }, [(_vm.previewImage) ? _c('img', {
    staticClass: "default-image",
    attrs: {
      "src": _vm.imageUrl,
      "alt": "default logo",
      "width": "46.8",
      "height": "38"
    }
  }) : _c('a', {
    attrs: {
      "href": _vm.imageUrl,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Open File")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.disableValidation) ? _c('span', {
    staticClass: "min-text"
  }, [_vm._v("MIN. " + _vm._s(_vm.minResolution) + "x" + _vm._s(_vm.minResolution))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "allowed-files"
  }, [_vm._v(_vm._s(_vm.allowedFiles.join(', ')))]), _vm._v(" "), _c('input', {
    attrs: {
      "id": _vm.labelFor,
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.onFileSelected
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera-button"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/camera.png",
      "alt": "camera button",
      "width": "13.3",
      "height": "10.8"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-606477c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/FileUpload/FileUpload.vue
// module id = 943
// module chunks = 6 8 9 10 11 12 31 46 51